var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8V2.5C7.5 2.22385 7.72363 2 8 2C8.27637 2 8.5 2.22385 8.5 2.5V7.79294L10.8535 10.1465C11.0488 10.3417 11.0488 10.6583 10.8535 10.8535C10.6582 11.0488 10.3418 11.0488 10.1465 10.8535L7.65332 8.36044L7.64648 8.35355C7.55615 8.26306 7.5 8.13806 7.5 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4185 16 8 16C3.58154 16 0 12.4183 0 8C0 3.58173 3.58154 0 8 0C12.4185 0 16 3.58173 16 8ZM15 8C15 11.866 11.8662 15 8 15C4.13379 15 1 11.866 1 8C1 4.134 4.13379 1 8 1C11.8662 1 15 4.134 15 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.c5ebec0bea99a7f7d5d29bc8a33f0c34.svg";
export { ForwardRef as ReactComponent };